/**
 * ==========================================================================
 * JHC MAIN CART
 * AJAX Cart
 * Shopify Online Store 2.0
 * ==========================================================================
 */

(() => {
  'use strict';

  class JhcCart {
    constructor() {
      this.cart = document.querySelector('.jhc-cart');

      if (!this.cart) return;

      this.form = this.cart.querySelector('#JhcCartForm');

      this.bindEvents();
    }

    /* --------------------------------------------------------------------------
       Events
    -------------------------------------------------------------------------- */

    bindEvents() {

      this.cart.addEventListener('click', (event) => {

        const button = event.target.closest('button');

        if (!button) return;

        if (button.dataset.action) {
          this.updateQuantity(button);
        }

        if (button.dataset.remove) {
          this.removeItem(button.dataset.remove);
        }

      });

      this.cart.addEventListener('change', (event) => {

        const input = event.target;

        if (!input.classList.contains('jhc-cart-item__qty-input')) return;

        this.changeItem(
          input.dataset.key,
          parseInt(input.value, 10)
        );

      });

    }

    /* --------------------------------------------------------------------------
       Quantity
    -------------------------------------------------------------------------- */

    updateQuantity(button) {

      const wrapper = button.closest('.jhc-cart-item');

      const input = wrapper.querySelector('.jhc-cart-item__qty-input');

      let quantity = parseInt(input.value, 10);

      if (button.dataset.action === 'increase') {
        quantity++;
      }

      if (button.dataset.action === 'decrease') {
        quantity = Math.max(0, quantity - 1);
      }

      input.value = quantity;

      this.changeItem(
        button.dataset.key,
        quantity
      );

    }

    /* --------------------------------------------------------------------------
       Remove
    -------------------------------------------------------------------------- */

    removeItem(key) {
      this.changeItem(key, 0);
    }

    /* --------------------------------------------------------------------------
       AJAX
    -------------------------------------------------------------------------- */

    async changeItem(key, quantity) {

      this.setLoading(true);

      const row = this.cart.querySelector(
        `[data-key="${key}"]`
      );

      if (row) {
        row.classList.add('is-updating');
      }

      try {

        const response = await fetch('/cart/change.js', {

          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({
            id: key,
            quantity: quantity
          })

        });

        if (!response.ok) {
          throw new Error('Cart update failed');
        }

        await response.json();

        await this.refresh();

      }

      catch (error) {

        console.error(error);

      }

      finally {

        if (row) {
          row.classList.remove('is-updating');
        }

        this.setLoading(false);

      }

    }

    /* --------------------------------------------------------------------------
       Refresh
    -------------------------------------------------------------------------- */

    async refresh() {

      const response = await fetch(window.location.pathname);

      const html = await response.text();

      const parser = new DOMParser();

      const documentHTML = parser.parseFromString(
        html,
        'text/html'
      );

      const freshCart = documentHTML.querySelector('.jhc-cart');

      if (!freshCart) return;

      this.cart.replaceWith(freshCart);

      this.cart = document.querySelector('.jhc-cart');

      this.form = this.cart.querySelector('#JhcCartForm');

      this.bindEvents();

      this.updateBubble();

    }

    /* --------------------------------------------------------------------------
       Cart Bubble
    -------------------------------------------------------------------------- */

    async updateBubble() {

      try {

        const response = await fetch('/cart.js');

        const cart = await response.json();

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: cart
          })
        );

      }

      catch (error) {

        console.error(error);

      }

    }

    /* --------------------------------------------------------------------------
       Loading
    -------------------------------------------------------------------------- */

    setLoading(state) {

      this.cart.classList.toggle(
        'is-loading',
        state
      );

    }

  }

  /* ==========================================================================
     Init
     ========================================================================== */

  const init = () => {

    new JhcCart();

  };

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();